module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/details.json
// module id = 299
// module chunks = 247016486310008